<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Minhas Contribuições' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-card (click)="openMeus()">
    <ion-card-content class="minhas">
      <ion-row>
        <ion-col>
          <i class="fas fa-hands-usd"></i>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="10">
          <div class="titulo">{{'Meus Planos' | translate}}</div>
        </ion-col>

        <ion-col style="display: flex; justify-content: end">
          <i class="fa-solid fa-chevron-right"></i>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>

  <ion-card (click)="openParcelas()">
    <ion-card-content class="parcelas">
      <ion-row>
        <ion-col>
          <i class="fa-solid fa-memo-circle-info"></i>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="10">
          <div class="titulo-two">{{'Parcelas em aberto' | translate}}</div>
        </ion-col>

        <ion-col style="display: flex; justify-content: end">
          <i class="fa-solid fa-chevron-right"></i>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</ion-content>
